export type SaveUserPermissionsDTO = {
  userId: string;
  rolePermission: rolePermissionDto[] | null;  
};

type rolePermissionDto = {
  key: string;
  permissions:Record<string, boolean>
}


export const actions = [
  { key: 'add', label: 'Add' },
  { key: 'delete', label: 'Delete' },
  { key: 'edit', label: 'Edit' },
  { key: 'view', label: 'View' },
  { key: 'print', label: 'Print/Export' },
];

export interface PermissionRow {
  menuId : number ;
  userId : number ;
  key: string;
  title: string;
  parentKey?: string | null;
  permissions: Record<string, boolean>;
}

export type UsersTopBarProps = {
  id: string;
};

export interface userMenu {
  id: string;
  menu: string;
  isPermission: boolean;
}

export type AddRole ={
  name : string ;
}

export type UpdateRole ={
  id:number ;
  role : string ;
  type : number ;
}

export type UpdateRoleResponse ={
  id:number ;
  name : string ;
  type : number ;
}


export type SaveRolePrivilegePermissionsDTO = {
  roleId: number;
  rolePermission: rolePermissionDto[] | null;  
};
export type roleTypeLists = {
  id:number,
  title:string
}